import toast from "react-hot-toast";
import { Navigate } from "react-router-dom";
import Loader from "../components/ui/loader";
import { useAuth } from "../context/auth-provider";
const AdminRoute = ({ children }) => {
  const { user, isLoading } = useAuth();
  if (isLoading)
    return (
      <>
        <Loader />
      </>
    );
  if (user?.typeOfUser === "admin") return children;
  toast.error("Its a seller only route");
  return <Navigate to={"/"} replace></Navigate>;
};

export default AdminRoute;
